// src/apiRoutes.js

const __VERSION__ = 'v3';

export default {
    api: {
        admins: `${__APIURL__}/${__VERSION__}/users/admin`,
        answers: `${__APIURL__}/${__VERSION__}/answers`,
        avatars: `${__APIURL__}/${__VERSION__}/avatars`,
        badges: `${__APIURL__}/${__VERSION__}/badges`,
        educationMaterials: `${__APIURL__}/${__VERSION__}/educationMaterials`,
        educationMaterialsDeletePicture: `${__APIURL__}/${__VERSION__}/educationMaterials/deletePicture`,
        login: `${__APIURL__}/${__VERSION__}/auth`,
        newsfeeds: `${__APIURL__}/${__VERSION__}/newsfeeds`,
        questions: `${__APIURL__}/${__VERSION__}/questions`,
        questionVideoUpload: `${__APIURL__}/${__VERSION__}/questions/uploadVideo`,
        questionVideoDelete: `${__APIURL__}/${__VERSION__}/questions/deleteVideos`,
        questionPictureDelete: `${__APIURL__}/${__VERSION__}/questions/deletePicture`,
        questionAnswers: `${__APIURL__}/${__VERSION__}/answers/question/`,
        requestPasswordReset: `${__APIURL__}/${__VERSION__}/users/createForgottenPasswordRequest`,
        resetPassword: `${__APIURL__}/${__VERSION__}/users/resetPassword`,
        stats: {
            questionSuccessRateByTag: `${__APIURL__}/${__VERSION__}/uqaLogs/statsByTags`,
            questionAnswers: `${__APIURL__}/${__VERSION__}/uqaLogs/questionLog`,
            accessLogs: `${__APIURL__}/${__VERSION__}/accessLogs/count`,
            moneyAccountsBalance: `${__APIURL__}/${__VERSION__}/moneyAccounts`,
            financeStats: `${__APIURL__}/${__VERSION__}/moneyAccounts/balanceByDays`,
            pointAccountsBalance: `${__APIURL__}/${__VERSION__}/pointAccounts`,
            uqaLogsRatio: `${__APIURL__}/${__VERSION__}/uqaLogs/getRatio`,
            testStats: `${__APIURL__}/${__VERSION__}/testings/getTestStats`,
            specialStats: `${__APIURL__}/${__VERSION__}/specials/specialStats`,
            edumatStats: `${__APIURL__}/${__VERSION__}/educationMaterials/edumatStats`,
            activeUsers: `${__APIURL__}/${__VERSION__}/uqaLogs/activeUsers`,
        },
        specials: `${__APIURL__}/${__VERSION__}/specials`,
        specialsDeletePicture:`${__APIURL__}/${__VERSION__}/specials/deletePicture`,
        awards: `${__APIURL__}/${__VERSION__}/awards`,
        tags: `${__APIURL__}/${__VERSION__}/tags`,
        users: `${__APIURL__}/${__VERSION__}/users`,
        userStories: `${__APIURL__}/${__VERSION__}/userStories`,
        userAwards: `${__APIURL__}/${__VERSION__}/userAwards`
    }
}



/** WEBPACK FOOTER **
 ** ./src/apiRoutes.js
 **/